import { useEffect, useState, useCallback } from "react";
import { getMode, setMode as persist, resolved } from "@/lib/theme";

export function useTheme() {
  const [mode, setModeState] = useState(getMode());
  useEffect(() => {
    const h = () => setModeState(getMode());
    window.addEventListener("fidalis-theme", h);
    return () => window.removeEventListener("fidalis-theme", h);
  }, []);
  const set = useCallback((m) => { persist(m); setModeState(m); }, []);
  const cycle = useCallback(() => {
    const order = ["light", "dark", "auto"];
    const next = order[(order.indexOf(getMode()) + 1) % order.length];
    persist(next); setModeState(next);
  }, []);
  return { mode, resolved: resolved(mode), set, cycle };
}
